/** Product name shown in sidebar header (no logo). */
export const PRODUCT_DISPLAY_NAME = 'NextFollowUp';

/** Sidebar title: agency name when set, otherwise product name. */
export function getSidebarBrandTitle(agency) {
  const name = (agency?.agencyName ?? '').trim();
  return name || PRODUCT_DISPLAY_NAME;
}
